import { createContext, useContext } from 'react';
import { useAppSelector } from '@/app/hooks';
import type { RootState } from '@/app/store';
import { toWebinarLng } from '@/lib/webinarLanguage';
import type { WebinarLanguage } from '@/features/webinar/types';

// Hors provider (régie, aperçus du back-office, page d'enregistrement), pas de langue imposée :
// les textes suivent la langue courante de l'interface.
const WebinarLanguageContext = createContext<string | undefined>(undefined);

// `language` : langue déjà connue de la page (salle de test), prioritaire sur les sessions publiques.
export function WebinarLanguageProvider({
  children,
  language: knownLanguage,
}: {
  children: React.ReactNode;
  language?: WebinarLanguage | null;
}) {
  const webinarSession = useAppSelector((s: RootState) => s.webinar.currentPublicSession);
  const liveSession = useAppSelector((s: RootState) => s.live.publicSession);
  const language = knownLanguage ?? webinarSession?.language ?? liveSession?.language;
  // Session pas encore chargée ou lien invalide : langue de l'interface plutôt que le français.
  const lng = language ? toWebinarLng(language) : undefined;

  return <WebinarLanguageContext.Provider value={lng}>{children}</WebinarLanguageContext.Provider>;
}

export function useWebinarLng(): string | undefined {
  return useContext(WebinarLanguageContext);
}
